// plugins/store-debug.js
export default ({ store }) => {
  if (process.client && process.env.NODE_ENV === 'development') {
    window.$store = store;
  }
}
